import DocumentsList from './styled';

export default DocumentsList;
